import React, { useEffect, useState } from "react";
import "../../layouts/Styles.css";
import { connect } from "react-redux";
import Tooltip from "react-power-tooltip";
import { BiListPlus } from "react-icons/bi";
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import { HiViewGridAdd } from "react-icons/hi";
import { FiSearch } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import { Actions } from "../../internals/app/Actions";
import AddProduct from "../../modules/product/views/AddProduct";

const ProductHeader = ({
  isGrid,
  setImage,
  searchText,
  toggleGridList,
  onSearchChange,
  resultCount,
  totalCount,
}: {
  isGrid: boolean;
  setImage: (image: string) => void;
  searchText: string;
  toggleGridList: (status: boolean) => void;
  onSearchChange: (value: string) => void;
  resultCount: number;
  totalCount: number;
}) => {
  const [searchParams] = useSearchParams();
  const [showGuide, setGuide] = useState<boolean>(false);
  const [isOpenProduct, setIsOpenProduct] = useState(false);

  useEffect(() => {
    const guide = searchParams.get("guide");
    if (guide) {
      setGuide(true);
    }
  }, [searchParams]);

  const toggleProduct = () => {
    setImage("");
    setIsOpenProduct(!isOpenProduct);
    setGuide(false);
  };

  return (
    <div className="flex flex-row w-full justify-between">
      <div className="flex flex-row flex-wrap gap-3 ">
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button
            type="button"
            onClick={() => toggleGridList(true)}
            className={
              "inline-flex gap-2 items-center px-4 py-2 text-sm font-medium border border-gray-200 rounded-l-lg hover:bg-gray-100 focus:z-10" +
              (isGrid
                ? " bg-gray-100 text-medium-slate-blue"
                : " bg-white text-gray-900")
            }
          >
            <HiViewGridAdd color={isGrid ? "#6D71F9" : "black"} size={20} />
            Grid
          </button>
          <button
            type="button"
            onClick={() => toggleGridList(false)}
            className={
              "inline-flex gap-2 items-center px-4 py-2 text-sm font-medium border border-gray-200 rounded-r-md hover:bg-gray-100 focus:z-10" +
              (!isGrid
                ? " bg-gray-100 text-medium-slate-blue"
                : " bg-white text-gray-900")
            }
          >
            <BiListPlus color={!isGrid ? "#6D71F9" : "black"} size={20} />
            List
          </button>
        </div>
      </div>

      <div className="flex flex-1 justify-center px-4">
        <div className="w-full max-w-md">
          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <FiSearch size={16} color="#9CA3AF" />
            </span>
            <input
              type="text"
              value={searchText}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="Search products, category, brand or barcode"
              aria-label="Search products"
              className="w-full h-[38px] pl-9 pr-9 text-sm text-gray-900 bg-white border border-gray-200 rounded-md outline-none focus:border-medium-slate-blue"
            />
            {searchText && (
              <button
                type="button"
                aria-label="Clear search"
                onClick={() => onSearchChange("")}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-700"
              >
                <AiOutlineClose size={14} />
              </button>
            )}
          </div>
          {searchText && (
            <p className="mt-1 text-xs text-gray-500">
              {resultCount} of {totalCount} products
            </p>
          )}
        </div>
      </div>

      <div className="flex flex-row flex-wrap gap-3 ">
        <div className="inline-flex rounded-md shadow-sm relative" role="group">
          <button
            type="button"
            className="inline-flex gap-2 items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-md hover:bg-gray-100 hover:text-medium-slate-blue"
            onClick={() => toggleProduct()}
          >
            <AiOutlinePlus size={20} />
            Add Product
          </button>
          {/* @ts-ignore */}
          <Tooltip
            // textBoxWidth="200px"
            show={showGuide}
            position="left center"
            backgroundColor="#6D71F9"
          >
            <p className="text-sm font-normal text-white">
              Create your new products by pressing Add Products
            </p>
          </Tooltip>
        </div>
      </div>
      <AddProduct isOpen={isOpenProduct} closeModal={() => toggleProduct()} />
    </div>
  );
};
export default connect((state: any) => ({}), {
  setImage: Actions.product.setImage,
})(ProductHeader);
